module.exports = __webpack_public_path__ + "static/tile-infrastructure-d9969d118ff0d714fdd60769739c8004.jpg";